import { createSlice } from "@reduxjs/toolkit";
import {
    getAllDesignationList
} from './thunk';

export const initialState = {
    designationList: [],
    errors: {}
};

const DesignationSlice = createSlice({
    name: 'Designation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllDesignationList.fulfilled, (state: any, action: any) => {
            state.designationList = action.payload;
        });
        builder.addCase(getAllDesignationList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default DesignationSlice.reducer;